import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  CountryISO,
  PhoneNumberFormat,
  SearchCountryField,
} from 'ngx-intl-tel-input';
import { ToastrService } from 'ngx-toastr';
import {
  MyAccountDto,
  MyaccountMobileOrEmailDto,
  Otp,
  RemoveDeviceDto,
  SendCommandDto,
  SendSettingStatusDto,
  TransferOwnershipDto,
} from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
import { CommonEnums } from 'src/app/utils/enum-utils';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CommonService } from 'src/app/services/common.service';
import * as moment from 'moment';
import { compareVersions } from 'compare-versions';
declare let $: any;

interface Device {
  activationDate: string | null;
  antiTheft: boolean;
  atStatus: string | null;
  autoRenewal: number | null;
  buildVersion: string | null;
  changeDate: string | null;
  computerName: string | null;
  crwDomainUrl: string | null;
  currentUserId: string | null;
  currentUserName: string | null;
  default: boolean;
  detected: boolean;
  deviceId: string | null;
  deviceName: string | null;
  devicePin: boolean;
  deviceType: 'SYSTEM' | 'MOBILE' | null;
  dpStatus: string | null;
  emailId: string | null;
  encryptedProductKey: string | null;
  expiringStatus: string | null;
  expirydays: number | null;
  firewallProtection: boolean;
  fpStatus: string | null;
  id: string;
  idsIpsProtection: boolean;
  idsIpsStatus: string | null;
  imeiNum: string | null;
  intruderAlert: boolean;
  isChecked: boolean;
  isSettingPresent: boolean | null;
  lastChangeName: string | null;
  lastSyncDate: string | null;
  lastSyncDateStr: string | null;
  licenseValidityDate: string | null;
  macAddress: string | null;
  make: string | null;
  masterKey: string | null;
  mobileNo: string | null;
  model: string | null;
  operatingSystem: string | null;
  osVersion: string | null;
  processorCount: string | null;
  productKey: string | null;
  productKeyType: string | null;
  productLink: string | null;
  productName: string | null;
  productType: string | null;
  ram: string | null;
  ransomwareProtection: boolean;
  rpOnTime: string | null;
  rpStatus: string | null;
  screenTime: boolean;
  securityStatus: string | null;
  simNum: string | null;
  smartParenting: boolean;
  spStatus: string | null;
  stStatus: string | null;
  systemColor: string | null;
  systemType: string | null;
  totalSpace: string | null;
  user: string | null;
  userRole: string | null;
  virusDate: string | null;
  virusProtection: boolean;
  vpOnTime: string | null;
  vpStatus: string | null;
  wirelessMacAddr: string | null;
  youtubeStatus: string | null;
  youtubeSupervision: boolean;
}

interface User {
  id: string;
  name: string;
  myUserDeviceList?: Device[];
  myUserLicenseList?: any[];
}

@Component({
  selector: 'app-manage-device',
  templateUrl: './manage-device.component.html',
  styleUrls: ['./manage-device.component.scss'],
})
export class ManageDeviceComponent implements OnInit {
  @ViewChild('ngOtpInput') ngOtpInputRef: any;
  @Output() isCollapseSidebar: any = new EventEmitter();
  @ViewChild('testInput') testInput: any;
  isLoading: boolean = false;
  antitheftData: any[] = [];
  isMobile: boolean = true;
  isOTP: boolean = false;
  isDone: boolean = false;
  timer: any;
  emailResponse: string = '';
  mobileOrEmailOTP: String;
  isEmailOTPSent: boolean = false;
  isEmailVerified: boolean = false;
  verifyMobileNumber: boolean;
  isSentOTP: boolean = false;
  isVerified: boolean = false;
  sentMobileNo: string = '';
  countryCode: string = '';
  submitOtpErrorMessage: string = '';
  durationMinutes: string = '';
  timeOver: any;
  isTransferOwnership: boolean = false;
  isDeviceRemoved: boolean = false;
  mobileOTPResponse: string = '';
  otpValue: string = '';
  isTransferSubmitted: boolean = false;
  mobileNumber: string = '';
  transferDto: TransferOwnershipDto = new TransferOwnershipDto();
  sendCommanddto: SendCommandDto = new SendCommandDto();
  sendSettingStatusDto: SendCommandDto = new SendSettingStatusDto();
  getRequestType: string = 'PHOTO';
  isPremium: boolean = false;
  tabsData: any = [];
  otpDto: Otp = new Otp();
  openMyDeviceContent: boolean = false;
  openUserDeviceContent: boolean = false;
  selectedLanguage: string = '';
  getUserIndexData: any;
  getMyIndexData: any;
  getMyIndexLicenseData: any;
  selectedUsersIndex: number = 0;
  loggedInUser: any;
  collapseShow = 'hidden';
  isFullSidebar: boolean = true;
  getUserDeviceData: any;
  getPopupDataById: any;
  selectedI: number = 0;
  productKeyToRemoveDevice: any;
  productKeyType: any = '';
  getMyDeviceData: any;
  getMyLicenseData: any;
  myAccountData: any;
  getTransferOwnershipUser: any;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  errorMessage: any;
  myUserDeviceCount: number = 0;
  owner: MyAccountDto = new MyAccountDto();
  PhoneNumberFormat = PhoneNumberFormat;
  selectedUserLicenseId: string = '';
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  emailOrMobileVerificationDto: MyaccountMobileOrEmailDto =
    new MyaccountMobileOrEmailDto();
  removeDeviceDto: RemoveDeviceDto = new RemoveDeviceDto();
  isMblDeviceSecure: boolean = false;
  isSystemSecure: boolean = false;
  isLicenseRemoved: boolean = false;
  deactiveDeviceName: string = '';
  productKeyTypeFa: string = '';
  errorMessageDeactivate: any;
  enableMyDeviceNameInput: boolean = false;
  enableMyUserDeviceNameInput: boolean = false;
  enableMyCurrentUserNameInput: boolean = false;
  enableMyUserNameInput: boolean = false;
  getUser: any;
  remoDeviceName: string = '';
  mobileNoWrong: boolean = false;
  deviceUpdatedName: string = '';
  updateName: string = '';
  addUserErrorMessage: any;
  emailSentUserName: any;
  language: any;
  modalForEng: boolean = false;
  isPaymentDone: boolean = false;
  showImage = false;
  loggedInUserId: string = '';
  cmdfailedDeviceName: String = '';
  requestTypes: String = '';
  crwSupportedProductTypes: string[] = [
    'QH_LITE',
    'QH_IS_ESSENTIAL',
    'QH_PLUS',
    'QH_TS',
  ];
  allOtherDevices: any[] = [];
  addDeviceForm: FormGroup = new FormGroup({
    deviceName: new FormControl(''),
    productKey: new FormControl(''),
  });

  autoDialForm: FormGroup = new FormGroup({
    mobileNo: new FormControl(''),
  });

  deviceDetailForm: FormGroup = new FormGroup({
    userName: new FormControl(''),
    countryCode: new FormControl(''),
  });

  addUserForm: FormGroup = new FormGroup({
    name: new FormControl(''),
    role: new FormControl(''),
    email: new FormControl(''),
  });

  transferOwnershipForm: FormGroup = new FormGroup({
    assignedUserId: new FormControl(''),
    deviceIdList: new FormControl(''),
  });
  isdeviceProducyKeyVerified: boolean = false;
  expanded: boolean = false;
  licenseExpanded: boolean = false;
  dcExpanded: boolean = false;
  getMyfirstIndexData: any;

  isLock: boolean = false;
  deviceId: string = '';
  isRing: boolean = false;
  Locked: boolean = true;
  lockData: boolean = false;
  id: string = '';
  buildVersion: any;
  deviceType: string;
  autodial: boolean = false;

  dropdownUsers: { id: string; name: string }[] = [];
  selectedUserId: string | null = null;
  selectedDevice: any = null;

  privacyStatusBg: String = 'rgba(222, 233, 254, 0.5)';
  privacyStatusClr: String = '#3F3F3F';
  expiryDate: any;
  isScanButtonDisabled = false;
  multiControlType: any;
  DeskCompatibleVer: any;
  mobileCompatibleVer: any;

  parseFloat = parseFloat;
  userTimezone: string;

  constructor(
    private _formBuilder: FormBuilder,
    private _service: ApiService,
    private _toastr: ToastrService,
    private _translate: TranslateService,
    private _router: Router,
    private _Service: ApiService,
    private _actRoute: ActivatedRoute,
    private translateService: TranslateService,
    private _commonService: CommonService
  ) {
    let tabsData = [];
    this.translateService.get(['SETTINGS']).subscribe((values) => {
      tabsData = Object.keys(values).map((key) => values[key]);
      this.tabsData = tabsData[0].ANTITHEFT_TABS;
    });
    this.addUserForm = this._formBuilder.group({
      name: ['', [Validators.required]],
      role: [''],
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            '^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([A-Za-z]{2,6}(?:\\.[A-Za-z]{2,6})?)$'
          ),
        ],
      ],
    });
    this.deviceDetailForm = this._formBuilder.group({
      userName: ['', [Validators.required]],
      countryCode: [''],
    });
  }

  // Get Enums
  public get CommonEnum(): typeof CommonEnums {
    return CommonEnums;
  }

  ngOnChanges(): void {
    setTimeout(() => {
      this.getAllDevice();
    }, 1000);
  }

  ngAfterViewInit() {
    this.selectedUsersIndex = 0;
    this.selectedI = 0;
    setTimeout(() => {
      this.testInput?.nativeElement?.focus();
    }, 1000);
  }
  UserId: any;
  selectedActionDeviceId: string;

  ngOnInit(): void {
    this.userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; // Fallback to UTC if not available
    this.allOtherDevices = [];
    this.selectedActionDeviceId = JSON.parse(sessionStorage.getItem('Deviceid')!) ?? '';
    this.isMblDeviceSecure = true;
    this.isSystemSecure = true;
    this.selectedDefaultLanguage();
    this._actRoute.paramMap.subscribe(params => {
      if (params.has('id')) {
        setTimeout(() => {
          this.UserId = this._actRoute.snapshot.paramMap.get('id');
          this.selectedUserId = this.UserId;
          this.onUserSelectionChange();
        }, 500);
      }
    });
    this._actRoute.queryParamMap.subscribe(params => {
      if (params.has('userId')) {
        const uid = params.get('userId');
        if (uid != undefined && uid != 'null') {
          setTimeout(() => {
            this.selectedUserId = uid;
            this.onUserSelectionChange();
          }, 500);
        }
      }
    });

    this.openMyDeviceContent = true;
    window.scrollTo(0, 0);
    this.selectedI = 0;
    this.transferOwnership();
    this.selectedDefaultLanguage();
    this.deviceDetail();
    this.gettransferownershipuser();

    let currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      this.loggedInUser = JSON.parse(currentUser);
    }

    this.language = localStorage.getItem('selectedLang');
    this.modalForEng = !(this.language && this.language !== 'en' && this.language !== '');

    setTimeout(() => {
      if (this.loggedInUser?.mobileNo) {
        this.deviceDetailForm.controls['userName'].setValue(this.loggedInUser.mobileNo);
      }
    }, 1000);

    // Read query parameters
    this._actRoute.queryParams.subscribe(params => {
      this.selectedUserId = params['userId'] || null;
      const deviceId: string | null = params['deviceId'] || null;

      // Load users first to ensure dropdownUsers is populated
      if (deviceId != null) {
        this.fetchAllUsersForDropdown(deviceId);
      } else if (this.UserId) {
        // only fetch selected user's devices
        this.selectedUserId = this.UserId;
        this.getAllDevice();
      } else {
        // fetch dropdown + all users' devices
        this.getUsersWithDevicesUnderMeAndLoadDevices();
      }

    });

    const storedDate = localStorage.getItem('bannerExpiryDate');
    this.expiryDate = storedDate ? new Date(storedDate) : null;
    const now = new Date();
    const nowDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const expiryDateOnly = new Date(
      this.expiryDate?.getFullYear() ?? 0,
      this.expiryDate?.getMonth() ?? 0,
      this.expiryDate?.getDate() ?? 0
    );
    this.showImage = nowDateOnly <= expiryDateOnly;
    this.DeskCompatibleVer = localStorage.getItem('DesktopCompatibleVersion');
    this.mobileCompatibleVer = (localStorage.getItem('MobileCompatibleVersion') || '').trim();
  }
  isCompatible(buildVersion: string): boolean {
    try {
      const parts = buildVersion.split('.');
      const trimmedParts = parts.length >= 5 ? parts.slice(0, 4) : parts;
      const cleanedVersion = trimmedParts.map(p => String(Number(p))).join('.');
      return compareVersions(cleanedVersion, this.mobileCompatibleVer) >= 0;
    } catch (error) {
      console.error('Invalid build version:', buildVersion, error);
      return false;
    }
  }

  getUsersWithDevicesUnderMeAndLoadDevices() {
    const apiUrl = this._service.API_URL.getAllDeviceDetail + '?myUserDevice=true' + '&timezone=' + encodeURIComponent(this.userTimezone) +
      `&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;
    this.isLoading = true;
    this.allOtherDevices = [];

    this._service.getService(apiUrl).subscribe((response: any) => {
      this.isLoading = false;

      if (response?.status?.code !== 200) {
        this._toastr.error('', response.status.message);
        return;
      }

      const userList = response.data?.myUserDeviceList || [];

      // Populate dropdown
      this.dropdownUsers = userList
        .filter((user: any) => user.myUserDeviceList?.length > 0)
        .map((user: any) => ({
          id: user.id,
          name: user.name,
        }));

      this.loggedInUserId = response.data.loggedInUserId;
      this.getUserDeviceData = userList;
      this.extractAndCombineDevices(userList);
      this.myUserDeviceCount = response.data.myUserCount;

      if (this.getMyDeviceData.length > 0) {
        this.selectedDevice = this.getMyDeviceData[0];

        this.getMyIndexData = this.selectedDevice;
        this.deviceUpdatedName = this.selectedDevice.deviceName;
        this.updateName = this.selectedDevice.currentUserName;
        this.selectedIndex(0, this.selectedDevice);
      }
    }, err => {
      this.isLoading = false;
      this._toastr.error('', this._translate.instant('MANAGEDEVICE.ERRORFETCHINGDEVICE'));
    });
  }


  getUsersWithDevicesUnderMeAndLoadDevicesForBack(deviceId: string | null = null) {
    this.isLoading = true;
    this.allOtherDevices = [];
    const apiUrl = this._service.API_URL.getAllDeviceDetail + '?myUserDevice=true' + '&timezone=' + encodeURIComponent(this.userTimezone) +
      `&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;
    this._service.getService(apiUrl).subscribe(
      (response: any) => {
        this.isLoading = false;

        if (response?.status?.code !== 200) {
          this._toastr.error('', response.status.message);
          return;
        }

        const userList: User[] = response.data?.myUserDeviceList || [];
        this.getUserDeviceData = userList;
        this.extractAndCombineDevices(userList);
        this.myUserDeviceCount = response.data.myUserCount;

        // Populate dropdownUsers
        this.dropdownUsers = userList
          .filter((user: User) => Array.isArray(user.myUserDeviceList) && user.myUserDeviceList.length > 0)
          .map((user: User) => ({
            id: user.id,
            name: user.name,
          }));

        // Validate selectedUserId
        if (this.selectedUserId && !this.dropdownUsers.some(user => user.id === this.selectedUserId)) {
          this.selectedUserId = null;
        }

        this.handleDeviceSelection(deviceId);
      },
      (err) => {
        this.isLoading = false;
        this._toastr.error('', this._translate.instant('MANAGEDEVICE.ERRORFETCHINGDEVICE'));
      }
    );
  }

  fetchAllUsersForDropdown(deviceId: string | null) {
    const apiUrl = this._service.API_URL.getAllDeviceDetail + '?myUserDevice=true' + '&timezone=' + encodeURIComponent(this.userTimezone) +
      `&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;
    this.isLoading = true;

    this._service.getService(apiUrl).subscribe(
      (response: any) => {
        this.isLoading = false;

        if (response?.status?.code !== 200) {
          this._toastr.error('', response.status.message);
          return;
        }

        this.getUserDeviceData = response.data.myUserDeviceList || [];
        this.dropdownUsers = this.getUserDeviceData
          .filter((user: User) => Array.isArray(user.myUserDeviceList) && user.myUserDeviceList.length > 0)
          .map((user: User) => ({
            id: user.id,
            name: user.name,
          }));

        this.myUserDeviceCount = response.data.myUserCount;

        // Validate selectedUserId
        if (this.selectedUserId && !this.dropdownUsers.some(user => user.id === this.selectedUserId)) {
          this.selectedUserId = null;
        }

        // Fetch devices based on selectedUserId or default to all devices
        if (this.UserId || this.selectedUserId) {
          if (deviceId != null) {
            this.getAllDeviceForBackButton(deviceId);
          } else {
            this.getAllDevice();
          }

        } else {
          if (deviceId != null) {
            this.getUsersWithDevicesUnderMeAndLoadDevicesForBack(deviceId);
          } else {
            this.getUsersWithDevicesUnderMeAndLoadDevices();
          }

        }
      },
      (err) => {
        this.isLoading = false;
        this._toastr.error('', this._translate.instant('MANAGEUSER.ERRORFETCHINGUSER'));
      }
    );
  }

  handleDeviceSelection(deviceId: string | null) {
    if (deviceId) {
      const index = this.getMyDeviceData.findIndex((device: Device) => device.id === deviceId);
      if (index !== -1) {
        this.selectedI = index;
        this.selectedDevice = this.getMyDeviceData[index];
        this.getMyIndexData = this.selectedDevice;
        this.deviceUpdatedName = this.selectedDevice.deviceName || '';
        this.updateName = this.selectedDevice.currentUserName || '';
        this.selectedIndex(index, this.selectedDevice);
      } else {
        if (this.getMyDeviceData.length > 0) {
          this.selectedI = 0;
          this.selectedDevice = this.getMyDeviceData[0];
          this.getMyIndexData = this.selectedDevice;
          this.deviceUpdatedName = this.selectedDevice.deviceName || '';
          this.updateName = this.selectedDevice.currentUserName || '';
          this.selectedIndex(0, this.selectedDevice);
        } else {
          this.selectedDevice = null;
        }
      }
    } else if (this.getMyDeviceData.length > 0) {
      this.selectedI = 0;
      this.selectedDevice = this.getMyDeviceData[0];
      this.getMyIndexData = this.selectedDevice;
      this.deviceUpdatedName = this.selectedDevice.deviceName || '';
      this.updateName = this.selectedDevice.currentUserName || '';
      this.selectedIndex(0, this.selectedDevice);
    } else {
      this.selectedDevice = null;
    }
  }

  onUserSelectionChange() {
    this.selectedDevice = null;
    if (this.selectedUserId != null) {
      this.getAllDevice();
    } else {
      this.UserId = null;
      this.fetchAllUsersForDropdown(this.selectedDevice);
    }
  }

  //  Fetching all the user For Assigning to the Transfer Ownership Modal(Popup)
  gettransferownershipuser() {
    this._service
      .getService(this._service.API_URL.gettransferownershipuser)
      .subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.getTransferOwnershipUser = response.data;
        }
      });
  }

  toggleContent() {
    this.expanded = !this.expanded;
  }
  toggleLicenseContent() {
    this.licenseExpanded = !this.licenseExpanded;
  }

  deviceControlToggle() {
    this.dcExpanded = !this.dcExpanded;
  }

  getStatusClass(status: string | null): string {
    switch (status) {
      case 'FAILED':
        return 'status-failed';
      case 'IN_PROGRESS':
        return 'status-inprogress';
      case 'APPLIED':
        return 'status-success';
      default:
        return 'status-success';
    }
  }

  // Disaplaying the data based on OnClick of the particular user Sidebar
  selectedUserIndex(index: any, data: any) {
    this.getCurrentIndex = index;
    this.getUserIndexData = [];
    this.getUserIndexData = data[index];
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.getLock(data.id);
    this.selectedI = index;
    this.getUserIndexData = data;
    this.selectedUserLicenseId = data.id;
    this.selectedUsersIndex = index;
    this.expanded = false;
    this.licenseExpanded = false;
    this.dcExpanded = false;
    this.enableMyDeviceNameInput = false;
    this.deviceUpdatedName = data.deviceName;
    this.updateName = data.currentUserName;
    const disabledUntil = localStorage.getItem('scanBtnDisabledUntil_' + data.id);
    if (disabledUntil && Date.now() < +disabledUntil) {
      this.isScanButtonDisabled = true;
      const timeLeft = +disabledUntil - Date.now();
      setTimeout(() => this.isScanButtonDisabled = false, timeLeft);
    } else {
      this.isScanButtonDisabled = false;
    }
  }
  //  Fetching all Devices to Display on the page
  myCount: number = 0;
  myUserDeviceList: any;

  getAllDevice() {
    this.isLoading = true;
    this.allOtherDevices = [];
    console.log("&selectedLang=:", this.selectedLanguage);
    let apiUrl =
      `${this._service.API_URL.getAllDeviceDetail}` +
      `?timezone=${encodeURIComponent(this.userTimezone)}` +
      `&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;

    if (this.selectedUserId != null) {
      // Specific user selected
      apiUrl += `&userId=${encodeURIComponent(this.selectedUserId)}`;
    } else {
      // No user selected = All users
      apiUrl += `&myUserDevice=true`;
    }

    console.log("apiUrl ::", apiUrl);

    this._service.getService(apiUrl).subscribe(
      (response: any) => {
        this.isLoading = false;

        if (response?.status?.code !== 200) {
          this._toastr.error('', response.status.message);
          return;
        }

        this.loggedInUserId = response.data.loggedInUserId;
        this.getMyDeviceData = [];
        this.getUserDeviceData = [];


        if (this.selectedUserId) {
          this.getMyDeviceData = (response.data.myDeviceList || []).map(
            (device: any) => {
              const matchedLicense = (response.data.myLicenseList || []).find(
                (license: any) => license.id === device.id
              );
              return {
                ...device,
                autoRenewal: matchedLicense?.autoRenewal ?? null,
                expirydays: matchedLicense?.expirydays ?? null,
              };
            }
          );

          this.myCount = this.getMyDeviceData.length;
        } else {
          // ALL USERS
          this.getUserDeviceData = response.data.myUserDeviceList || [];
          this.extractAndCombineDevices(this.getUserDeviceData);
          this.myUserDeviceCount = response.data.myUserCount;
          this.fetchAllUsersForDropdown(this.selectedDevice);
        }
        this.selectedDevice =
          this.getMyDeviceData.length > 0 ? this.getMyDeviceData[0] : null;
        this.getMyIndexData = this.getMyDeviceData[0];
        this.deviceUpdatedName = this.getMyDeviceData[0]?.deviceName;
        this.updateName = this.getMyDeviceData[0]?.currentUserName;
        this.selectedIndex(0, this.selectedDevice);
      },
      (err) => {
        this.isLoading = false;
        this._toastr.error('', this._translate.instant('MANAGEUSER.ERRORFETCHINGUSER'));
      }
    );
  }


  getAllDeviceForBackButton(deviceId: string | null = null) {
    this.isLoading = true;
    this.allOtherDevices = [];
    let apiUrl = `${this._service.API_URL.getAllDeviceDetail}?timezone=${encodeURIComponent(this.userTimezone)}` +
      `&selectedLang=${encodeURIComponent(this.selectedLanguage)}`;
    if (this.selectedUserId) {
      apiUrl += '&userId=' + this.selectedUserId;
    } else {
      apiUrl += '&myUserDevice=true';
    }

    this._service.getService(apiUrl).subscribe(
      (response: any) => {
        this.isLoading = false;

        if (response?.status?.code !== 200) {
          this._toastr.error('', response.status.message);
          return;
        }

        this.loggedInUserId = response.data.loggedInUserId;
        this.getMyDeviceData = [];

        // Populate devices
        this.getMyDeviceData = (response.data.myDeviceList || []).map(
          (device: Device) => {
            const matchedLicense = (response.data.myLicenseList || []).find(
              (license: any) => license.id === device.id
            );
            return {
              ...device,
              autoRenewal: matchedLicense?.autoRenewal ?? null,
              expirydays: matchedLicense?.expirydays ?? null,
            };
          }
        );

        this.myCount = this.getMyDeviceData.length;

        // Validate selectedUserId (dropdownUsers is populated by fetchAllUsersForDropdown)
        if (this.selectedUserId && !this.dropdownUsers.some(user => user.id === this.selectedUserId)) {
          console.warn('getAllDevice - selectedUserId not found in dropdownUsers:', this.selectedUserId);
          this.selectedUserId = null;
        }
        if (deviceId != null) {
          this.handleDeviceSelection(deviceId);
        }

      },
      (err) => {
        this.isLoading = false;
        this._toastr.error('', this._translate.instant('MANAGEDEVICE.ERRORFETCHINGDEVICE'));
      }
    );
  }

  extractAndCombineDevices(userList: User[]) {
    this.getMyDeviceData = userList.flatMap(user => {
      const licenseMap = new Map(
        (user.myUserLicenseList ?? []).map(l => [l.id, l])
      );

      return (user.myUserDeviceList ?? []).map(device => {
        const license = licenseMap.get(device.id);
        return {
          ...device,
          expirydays: license?.expirydays ?? null,
        };
      });
    });
    console.log('Combined Devices:', this.getMyDeviceData);
  }

  // Selected Language - VInit
  selectedDefaultLanguage() {
    let selectedLangStringValue = localStorage.getItem('selectedLang');
    if (selectedLangStringValue) {
      this.selectedLanguage = selectedLangStringValue;
      this._translate.use(this.selectedLanguage);
    }
  }

  //Transfer Ownership Popup Form Declaration - Deepa
  transferOwnership() {
    this.transferOwnershipForm = this._formBuilder.group({
      assignedUserId: ['', [Validators.required]],
    });
  }

  //  Opening thr Transfer Ownership Modal
  openTransferOwnershipModal(id: any) {
    this.isTransferOwnership = false;
    this.owner.id = id.currentUserId;
    this.owner.name = id.currentUserName;
    $('#transferOwnerShipBefore').modal('show');
  }

  //closing modal and navigating to transfer ownership page with users
  openTransferOwnershipPage() {
    $('#transferOwnerShipBefore').modal('hide');
    this._commonService.setUserData(this.owner);
    this._router.navigate(['home/change-owner'], {
      state: { prevPage: this._router.url },
    });
  }

  transferOwnershipUsername(evt: any) {
    this.getTransferOwnershipUser.forEach((element: any) => {
      if (element.id === evt) {
        this.getUser = element.name;
      }
    });
    if (evt == this.loggedInUser.id) {
      this.getUser = this.loggedInUser.name;
    }
  }

  closeSuccessModal() {
    $('#transferOwnershipPopup').modal('hide');
    this.transferOwnershipForm.controls['assignedUserId'].setValue(null);
  }
  //  Fetching the Device Details based on the Id for the transfer ownership

  getDeviceDetailsById(id: any) {
    try {
      this._service
        .getService(this._service.API_URL.getDeviceDetailsById + id)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.getPopupDataById = response.data;
          } else {
            this._toastr.error('', response.status.message);
            this.isLoading = false;
          }
        });
    } catch (error) { }
  }

  //Device Detail Popup Form Declaration - Deepa
  deviceDetail() {
    this.deviceDetailForm = this._formBuilder.group({
      userName: ['', [Validators.required]],
      countryCode: [''],
    });
  }

  // TrackBy for performance
  trackByUserId(index: number, user: { id: string; name: string }): string {
    return user.id;
  }

  //Transfer Ownership Popup Form Data Submit - Deepa
  onTransferOwnership() {
    try {
      let arr = [];
      arr.push(this.getPopupDataById.id);
      this.isTransferSubmitted = true;
      this.isTransferOwnership = false;
      (this.transferDto.currentUserId = this.getPopupDataById.currentUserId),
        (this.transferDto.deviceIdList = arr),
        (this.transferDto.assignedUserId =
          this.transferOwnershipForm.controls['assignedUserId'].value);
      this._service
        .putService(
          this._service.API_URL.manageDeviceTransferOwnership,
          this.transferDto
        )
        .subscribe((response: any) => {
          if (response.status.code === 200) {
            this.isTransferOwnership = true;

            setTimeout(() => {
              this.selectedUsersIndex = 0;
              this.selectedI = 0;
              this.getAllDevice();
            }, 200);
          } else {
            this.isTransferOwnership = false;
            this._toastr.error('', response.status.message);
          }
        });
    } catch (error) { }
  }

  onOtpChange(event: any) {
    this.otpError = null;
    this.otpValue = event;
  }

  //  To get the Otp for the tranferownership
  otpError: any;
  submitOTP() {
    try {
      if (this.otpValue?.length == 4) {
        this.otpDto.otpNo = this.otpValue;
        this.otpDto.otpType = CommonEnums.MOBILE_VERIFICATION;
        this.otpDto.otpChar = this.emailResponse;
        this._service
          .postService(this._service.API_URL.otpVerification, this.otpDto)
          .subscribe((response: any) => {
            if (response && response.status.code === 200) {
              $('#verifyDetailsPopup').modal('show');
              this.isOTP = false;
              this.isDone = true;
            } else {
              this.otpError = response.status.message;
            }
          });
      }
    } catch (e) { }
  }

  //  Remove Added Device from the list

  onRemoveDevice() {
    let data = {
      productKeyOrDeviceId: '',
      productKeyTypeId: '',
      deactivate: '',
    };
    this._service
      .postService(this._service.API_URL.removeDevice, data)
      .subscribe((response: any) => {
        if (response.status.code === 200) {
          this.isDeviceRemoved = true;
        } else {
          this.isDeviceRemoved = false;
          this._toastr.error('', response.status.message);
        }
      });
  }

  //  Set the device as Default
  onSetAsDefault(item: any) {
    try {
      this._service
        .getService(this._service.API_URL.setDefault + '/' + item.id)
        .subscribe((response: any) => {
          if (response.status.code === 200) {
            this._toastr.success('', response.status.message);
            setTimeout(() => {
              if (this.getMyIndexData) {
                this.getMyIndexData.default = true;
              } else {
                this.getUserIndexData.default = true;
              }
              this.getAllDevice();
            }, 100);
          } else {
            this._toastr.error('', response.status.message);
          }
        });
    } catch (error) { }
  }

  //Verify Device Popup Form Data Submit - Deepa
  verifyDeviceDetail() {
    try {
      this.mobileNumber =
        this.deviceDetailForm.controls['userName'].value.number;
      let data = {
        userName: this.deviceDetailForm.controls['userName'].value.number,
        countryCode: this.deviceDetailForm.controls['userName'].value.dialCode,
        otpType: CommonEnums.MOBILE_VERIFICATION,
      };

      this.sentMobileNo =
        this.deviceDetailForm.controls['userName'].value.number;
      this.countryCode =
        this.deviceDetailForm.controls['userName'].value.dialCode;
      this._service
        .postService(this._service.API_URL.generateOTP, data)
        .subscribe((response: any) => {
          if (response.status.code === 200) {
            if (response.status.msgCode == 'MOBILE_VERIFICATION') {
              this.isMobile = false;
              this.isOTP = false;
              this.isDone = true;
            } else {
              this.emailResponse = response.data;
              this.isMobile = false;
              this.mobileOTPResponse = response.data;
              this.isOTP = true;
              this.timeOver = true;
              this.startTimerForFiveMinute(3);
            }
          } else {
            this.isOTP = false;
            this._toastr.error('', response.status.message);
          }
        });
    } catch (error) { }
  }

  getCurrentIndex: number = 0;
  selectedIndex(i: number, data: Device) {
    this.getCurrentIndex = i;
    this.getMyIndexData = null;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.selectedI = i;
    this.getMyIndexData = data;
    if (data?.deviceType === 'MOBILE') {
      this.getLock(data.id);
    }
    this.expanded = false;
    this.licenseExpanded = false;
    this.dcExpanded = false;
    this.enableMyDeviceNameInput = false;
    this.deviceUpdatedName = data?.deviceName || '';
    this.updateName = data?.currentUserName || '';
    const disabledUntil = localStorage.getItem('scanBtnDisabledUntil_' + data.id);
    if (disabledUntil && Date.now() < +disabledUntil) {
      this.isScanButtonDisabled = true;
      const timeLeft = +disabledUntil - Date.now();
      setTimeout(() => (this.isScanButtonDisabled = false), timeLeft);
    } else {
      this.isScanButtonDisabled = false;
    }
    this.selectedIndexfailure(this.getMyDeviceData[i]);
  }

  toggleCollapseShow(classes: any) {
    this.collapseShow = classes;
  }

  collapseSidebar(val: any) {
    this.isFullSidebar = !this.isFullSidebar;
    this.isCollapseSidebar.emit(val);
  }

  // Removing the added device from add device
  removeDevicePopup(data: any) {
    this.remoDeviceName = data.deviceName;
    this.productKeyToRemoveDevice = data.id;
    this.productKeyType = data.deviceType;
    $('#removeDevicePopup').modal('show');
  }
  actNowPopup() {
    $('#actNowPopup').modal('show');
  }

  deviceCommandsPopup() {
    $('#deviceCommandPopup').modal('show');
  }

  removeAddedDevice() {
    try {
      if (this.productKeyType === 'FAMILY_PACK') {
        (this.removeDeviceDto.productKeyType = this.productKeyType),
          (this.removeDeviceDto.productKeyOrDeviceId =
            this.productKeyToRemoveDevice),
          (this.removeDeviceDto.deactivate = true);
      } else {
        (this.removeDeviceDto.productKeyType = this.productKeyType),
          (this.removeDeviceDto.productKeyOrDeviceId =
            this.productKeyToRemoveDevice),
          (this.removeDeviceDto.deactivate = false);
      }

      this._service
        .postService(
          this._service.API_URL.removeAddedDevice,
          this.removeDeviceDto
        )
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this._toastr.success('', response.status.message);
            $('#removeDevicePopup').modal('hide');
            this.getAllDevice();
          }
        });
    } catch (error) { }
  }

  //  DeActivate device
  deactivate(item: any) {
    $('#deActivateDevicePopup').modal('show');
    this.isLicenseRemoved = false;
    this.deactiveDeviceName = item.deviceName;
    this.productKeyToRemoveDevice = item.id;
    this.productKeyTypeFa = item.deviceType;
  }

  deActivateAddedDevice() {
    try {
      (this.removeDeviceDto.productKeyType = this.productKeyTypeFa),
        (this.removeDeviceDto.productKeyOrDeviceId =
          this.productKeyToRemoveDevice),
        (this.removeDeviceDto.deactivate = true);
      this._service
        .postService(
          this._service.API_URL.removeAddedDevice,
          this.removeDeviceDto
        )
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this._toastr.success('', response.status.message);
            this.isLicenseRemoved = true;
            $('#deActivateDevicePopup').modal('hide');
            this.getAllDevice();
          } else if (response && response.status.code === 400) {
            this.errorMessageDeactivate = response.status.message;
            this._toastr.error('', response.status.message);
            $('#deActivateDevicePopup').modal('hide');
          }
        });
    } catch (error) { }
  }

  checkBeforeRenew() {
    if (this.getMyIndexData.productType === 'MOBSEC_ADVANCE') {
      $('#AntiTheftPopup').modal('hide');
      $('#renewPopup').modal('show');
    } else {
      this.openMyIndexRenewLicense(this.getMyIndexData);
    }
  }

  checkBeforeUserRenew() {
    if (this.getUserIndexData.productType === 'MOBSEC_ADVANCE') {
      $('#renewPopup').modal('show');
    } else {
      this.openMyIndexRenewLicense(this.getUserIndexData);
    }
  }

  openMyIndexRenewLicense(data: any, type?: string) {
    let prdkey = '';
    let url = '';

    if (this.userTimezone == 'Asia/Kolkata' || this.userTimezone == 'Asia/Calcutta') {
      if (this.selectedLanguage && this.selectedLanguage !== 'en') {
        prdkey = this.crwSupportedProductTypes.includes(data?.productType)
          ? data.productKey : '';
        url = `${data.productLink}?prdkey=${prdkey}&QVER=${data.buildVersion}`;
      } else {
        prdkey = this.crwSupportedProductTypes.includes(data?.productType)
          ? data.encryptedProductKey
          : data.productKey;

        url = `${data.productLink}?prdkey=${prdkey}`;
      }

    } else {
      prdkey = this.crwSupportedProductTypes.includes(data?.productType)
        ? data.productKey : '';
      url = `${data.productLink}?prdkey=${prdkey}&QVER=${data.buildVersion}`;
    }
    const newTab = window.open(url, '_blank');

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== data.crwDomainUrl) return;

      if (event.data === 'payment_success') {
        window.removeEventListener('message', messageHandler);
        this.handlePaymentSuccess(data.productKey);
      } else {
        window.removeEventListener('message', messageHandler);
      }
    };
    window.addEventListener('message', messageHandler);
    const tabWatcher = setInterval(() => {
      if (newTab?.closed) {
        clearInterval(tabWatcher);
        window.removeEventListener('message', messageHandler);
      }
    }, 500); // Check every 500ms
  }

  handlePaymentSuccess(productKey: string): void {
    this.isPaymentDone = true;
    this.getDesktopProductKeyDetails(productKey);
    // Update license list or redirect
  }

  updateProductKeyLicenceDetails(
    productKeyOrDeviceId: string,
    deviceType: string,
    userIndexType: string
  ) {
    if (deviceType == 'MOBILE') {
      this.getMobileProductKeyDetails(productKeyOrDeviceId, userIndexType);
    } else {
      this.getDesktopProductKeyDetails(productKeyOrDeviceId);
    }
  }

  getDesktopProductKeyDetails(productKey: string): void {
    this.isLoading = true;
    try {
      this._service
        .getService(
          this._service.API_URL.getDesktopProductKeyDetails +
          '?productKey=' +
          productKey
        )
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            if (response.data.expiryDate != null) {
              this.getMyIndexData.licenseValidityDate = response.data.expiryDate;
            }
            if (response.data.activationDate != null) {
              this.getMyIndexData.activationDate = response.data.activationDate;
            }
            if (response.data.buildVersion != null) {
              this.getMyIndexData.buildVersion = response.data.buildVersion;
            }
            if (response.data.productName != null) {
              this.getMyIndexData.productName = response.data.productName;
            }
            if (response.data.autoRenewal != null) {
              this.getMyIndexData.autoRenewal = response.data.autoRenewal;
            }
            this.isLoading = false;
            // this.getAllDevice();
          } else {
            this.isLoading = false;
          }
        });
    } catch (error) {
      this.isLoading = false;
      console.log(error);
    }
  }

  getMobileProductKeyDetails(deviceId: string, userIndex: string): void {
    this.isLoading = true;
    try {
      this._service
        .getService(
          this._service.API_URL.getMobileProductKeyDetails +
          '?deviceId=' +
          deviceId
        )
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            if (userIndex === 'myIndexData') {

              if (response.data.expiryDate != null) {
                this.getMyIndexData.licenseValidityDate =
                  response.data.expiryDate;
              }

              if (response.data.activationDate != null) {
                this.getMyIndexData.activationDate = response.data.activationDate;
              }

              if (response.data.autoRenewal != null) {
                this.getMyIndexData.autoRenewal =
                  response.data.autoRenewal;
              }

              if (response.data.buildVersion != null) {
                this.getMyIndexData.buildVersion =
                  response.data.buildVersion;
              }

              if (response.data.productName != null) {
                this.getMyIndexData.productName =
                  response.data.productName;
              }

            } else {
              if (response.data.expiryDate != null) {
                this.getUserIndexData.licenseValidityDate =
                  response.data.expiryDate;
              }

              if (response.data.activationDate != null) {
                this.getUserIndexData.activationDate =
                  response.data.activationDate;
              }

              if (response.data.autoRenewal != null) {
                this.getUserIndexData.autoRenewal =
                  response.data.autoRenewal;
              }

              if (response.data.buildVersion != null) {
                this.getUserIndexData.buildVersion =
                  response.data.buildVersion;
              }

              if (response.data.productName != null) {
                this.getUserIndexData.productName =
                  response.data.productName;
              }
            }

            this.isLoading = false;
            // this.getAllDevice();
          } else {
            this.isLoading = false;
          }
        });
    } catch (error) {
      this.isLoading = false;
      console.log(error);
    }
  }

  licenseHistoryRecords: any[] = [];
  getLicenseHistory(productData: any) {
    let a = [];
    let checkOne, checkTwo, changedFormat;
    this.licenseHistoryRecords = [];
    try {
      this._service
        .getService(
          this._service.API_URL.getLicenseHistory + '?productKey=' + productData
        )
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.licenseHistoryRecords = response.data?.licenseHistoryRecords;
            this.licenseHistoryRecords.forEach((res: any) => {
              checkOne = res.activityActionMessage.split(
                '<span class=istTimeFromMillisec>'
              );
              checkTwo = checkOne[1].split('</span>');
              checkTwo[0] = Number(checkTwo[0]);
              changedFormat = moment(new Date(checkTwo[0])).format(
                'DD/MM/YYYY HH:mm:ss'
              );
              res.activityActionMessage =
                checkOne[0] + changedFormat + checkTwo[1];
            });
          }
        });
    } catch (error) { }
  }

  closeDeactivate() {
    this.errorMessageDeactivate = null;
    $('#deActivateDevicePopup').modal('hide');
    $('#actNowPopup').modal('hide');
  }
  // Sending it to the setting Page

  gotoSettings(id: any) {
    this._router.navigateByUrl(`/home/settings/${id}`);
  }

  //  Checking here if Mobile is verified Or No
  isMobileVerified: boolean = false;
  goToAddDevice() {
    this.otpError = null;
    try {
      if (this.loggedInUser.mobileVerified) {
        this._router.navigateByUrl('/home/add-device');
      } else {
        this._service
          .getService(this._service.API_URL.checkVerifiedMobile)
          .subscribe((response) => {
            if (response && response.status.code === 200) {
              if (response.data == true) {
                this._router.navigateByUrl('/home/add-device');
              } else {
                this.isMobile = true;
                this.isOTP = false;
                this.isDone = false;
                $('#verifyDetailsPopup').modal('show');
              }
            } else {
              this.isLoading = false;
              this._toastr.error('', response.status.message);
            }
          });
      }
    } catch (error) { }
  }

  goToAddUser() {
    try {
      $('#transferOwnershipPopup').modal('hide');
      $('#addUserPopup').modal('show');
    } catch (error) {
      console.error();
    }
  }
  //  To Add the User Logic has been implemented here
  onAddUser() {
    try {
      if (this.loggedInUser.roleType === 'ADMIN') {
        this.addUserForm.controls['role'].setValue('MEMBERS');
      }
      this.emailSentUserName = this.addUserForm.controls['email'].value;
      this.addUserErrorMessage = null;
      this._service
        .postService(this._service.API_URL.addUser, this.addUserForm.value)
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            $('#addUserPopup').modal('show');
            this.isDone = true;
            this.addUserForm.controls['email'].setValue(null);
            this.addUserForm.controls['role'].setValue('');
            this.addUserForm.controls['name'].setValue(null);
            this.addUserErrorMessage = null;
          } else {
            this.addUserErrorMessage = response.status.message;
          }
        });
    } catch (error) { }
  }

  //  Start timer for Email Verification, Forgot Password
  startTimerForFiveMinute(minute: number) {
    let seconds: number = minute * 60;
    let textSec: any = '0';
    let statSec: number = 60;
    const prefix = minute < 10 ? '0' : '';
    this.timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;

      this.durationMinutes = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        this.timeOver = false;
        clearInterval(this.timer);
      }
    }, 1000);
  }

  closeModalForMobileNumber() {
    this.isMobile = true;
    this.isOTP = false;
    this.isDone = false;
    this.deviceDetailForm.reset();
    $('#verifyDetailsPopup').modal('hide');
  }

  //  Closing Add User Modal(Popup) here
  closeAddUserModal() {
    $('#addUserPopup').modal('hide');
    this.addUserForm.controls['email'].setValue(null);
    this.addUserForm.controls['name'].setValue(null);
    this.addUserForm.controls['role'].setValue('');
    this.addUserErrorMessage = null;
  }

  resendOtp() {
    try {
      this.otpError = null;
      this.ngOtpInputRef.setValue(null);
      clearInterval(this.timer);
      this.isOTP = true;
      this.timeOver = true;
      this.isMobile = false;
      let vinit = this.sentMobileNo;
      let countryCode = this.countryCode;

      let data = {
        userName: vinit,
        countryCode: countryCode,
        otpType: CommonEnums.MOBILE_VERIFICATION,
        isResendOTP: true,
      };
      this._service
        .postService(this._service.API_URL.generateOTP, data)
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            if (response.status.msgCode == 'MOBILE_VERIFICATION') {
              this.isMobile = false;
              this.isOTP = false;
              this.isDone = true;
            } else {
              this.emailResponse = response.data;
              this.isMobile = false;
              this.isOTP = true;
              this.timeOver = true;
              this.startTimerForFiveMinute(3);
            }
          } else {
            this.otpError = response.status.message;
            this.timeOver = false;
          }
        });
    } catch (e) { }
  }

  // Checking on Mobie validation on Focus Out and Verifying
  onFocusOutMobile(event: any) {
    if (event && event.number?.length < 8) {
      this.mobileNoWrong = true;
    } else {
      this.mobileNoWrong = false;
    }
  }
  removeSpace(event: any, name: any) {
    if (name == 'email') {
      if (event.code === 'Space') {
        event.preventDefault();
      }
    } else {
      if (event.target.selectionStart === 0 && event.code === 'Space') {
        event.preventDefault();
      }
    }
  }
  onlyAlphabets(event: any) {
    if (event.target.selectionStart === 0) {
      if (/\d/g.test(event.key)) event.preventDefault();
    }
  }
  keyPressAlphaNumericWithCharacters(event: any, name: any) {
    let k;
    if (name == 'email') {
      if (event.target.selectionStart === 0) {
        k = event.charCode; //         k = event.keyCode;  (Both can be used)
        return (
          (k > 64 && k < 91) ||
          (k > 96 && k < 123) ||
          k == 8 ||
          k == 32 ||
          (k >= 48 && k <= 57)
        );
      }
    } else if (event.target.selectionStart === 0) {
      k = event.charCode; //         k = event.keyCode;  (Both can be used)
      return (
        (k > 64 && k < 91) ||
        (k > 96 && k < 123) ||
        k == 8 ||
        k == 32 ||
        (k >= 48 && k <= 57)
      );
    } else if (name == 'name') {
      let inp = String.fromCharCode(event.keyCode);
      // Allow numbers, alpahbets, space, underscore
      if (/[a-zA-Z0-9-_ ]/.test(inp)) {
        return true;
      } else {
        event.preventDefault();
        return false;
      }
    }
  }

  // Updated Send Command for Scan device -> send Command + getDevicesInUser
  restorePublishForm: FormGroup = new FormGroup({
    mobileDeviceName: new FormControl(''),
  });
  mobileDevice: any[] = [];
  deviceName: any;
  // errorMessage: string = ''
  sendCommand(id: any, type: any) {
    // getDevicesInUser
    this._Service
      .getService(this._Service.API_URL.getDevicesInUser)
      .subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.mobileDevice = response.data;
          if (this.deviceId) {
            this.mobileDevice.forEach((element: any) => {
              if (this.deviceId == element.id) {
                this.deviceName = element.deviceName;
                this.restorePublishForm.controls['mobileDeviceName'].setValue(
                  element.id
                );
              }
            });
          } else {
            let deviceId = response.data[0].id;
            this.restorePublishForm.controls['mobileDeviceName'].setValue(
              deviceId
            );
          }
        } else {
          this.isLoading = false;
        }
      });

    this.isLoading = true;
    try {
      this.sendCommanddto.deviceId = id;
      this.sendCommanddto.requestType = 'SCAN_FROM_CLOUD';
      this.sendCommanddto.productKeyType = 'MOBILE';
      this._Service
        .postService(this._Service.API_URL.sendCommand, this.sendCommanddto)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            // $("#LockPopup").modal("show");
            this.isLock = false;
            // setTimeout("$('#LockPopup').modal('hide');", 1500);
            this._toastr.success(this._translate.instant('TOSTRMSGS.QH_TOSTR_SCAN_COMMAND'));
          } else {
            this._toastr.error('', response.status.message);
            this.isLoading = false;
          }
        });
    } catch (error) {
      this.isLoading = false;
    }
  }

  // Updated Send Command for Ring device -> send Command + getDevicesInUser

  sendCommand1(id: any, type: any) {
    // getDevicesInUser
    this.isLoading = true;
    try {
      this._Service
        .getService(this._Service.API_URL.getDevicesInUser)
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this.mobileDevice = response.data;
            if (this.deviceId) {
              this.mobileDevice.forEach((element: any) => {
                if (this.deviceId == element.id) {
                  this.deviceName = element.deviceName;
                  this.restorePublishForm.controls['mobileDeviceName'].setValue(
                    element.id
                  );
                }
              });
            } else {
              let deviceId = response.data[0].id;
              this.restorePublishForm.controls['mobileDeviceName'].setValue(
                deviceId
              );
            }
          } else {
            this.isLoading = false;
          }
        });
    } catch (error) {
      this.isLoading = false;
    }

    this.isLoading = true;
    try {
      this.sendCommanddto.deviceId = id;
      this.sendCommanddto.requestType = 'RING';
      this._Service
        .postService(this._Service.API_URL.sendCommand, this.sendCommanddto)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            // $("#LockPopup").modal("show");

            this.isRing = false;
            this._toastr.success(this._translate.instant('TOSTRMSGS.QH_TOSTR_RING_COMMAND'));
            // setTimeout("$('#LockPopup').modal('hide');", 1500);
          } else {
            this._toastr.error('', response.status.message);
            this.isLoading = false;
          }
        });
    } catch (error) {
      this.isLoading = false;
    }
  }

  // Updated Send Command for Wipe -> send Command + getDevicesInUser
  sendCommand2() {
    $('#WipePopup').modal('show');
    this.isLock = false;
  }

  // updated send command for wipe
  sendCommand3(id: any, type: any) {
    this.isLoading = true;
    try {
      this._Service
        .getService(this._Service.API_URL.getDevicesInUser)
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this.mobileDevice = response.data;
            if (this.deviceId) {
              this.mobileDevice.forEach((element: any) => {
                if (this.deviceId == element.id) {
                  this.deviceName = element.deviceName;
                  this.restorePublishForm.controls['mobileDeviceName'].setValue(
                    element.id
                  );
                }
              });
            } else {
              let deviceId = response.data[0].id;
              this.restorePublishForm.controls['mobileDeviceName'].setValue(
                deviceId
              );
            }
          } else {
            this.isLoading = false;
          }
        });
    } catch (error) {
      this.isLoading = false;
    }

    this.isLoading = true;
    try {
      this.sendCommanddto.deviceId = id;
      this.sendCommanddto.requestType = 'WIPE';
      this._Service
        .postService(this._Service.API_URL.sendCommand, this.sendCommanddto)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this._toastr.success('', response.status.message);
            this.isLock = true;
          } else {
            this.isLoading = false;
            this._toastr.error('', response.status.message);
          }
          this.isLoading = false;
        });
    } catch (error) {
      this.isLoading = false;
    }
  }

  //  Closing the modal on wipe
  closeModal() {
    $('#WipePopup').modal('hide');
    this.isLock = false;
    this.errorMessage = '';
  }

  closeModal2() {
    $('#WipePopup').modal('hide');
  }

  //pop logic for lock
  sendCommand4() {
    this.errorMessage = null;
    $('#LockPopup1').modal('show');
    this.isLock = false;
  }

  // updated Send Command for lock
  sendCommand5(id: any, type: any) {
    // getDevicesInUser()
    this.isLoading = true;
    try {
      this._Service
        .getService(this._Service.API_URL.getDevicesInUser)
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this.mobileDevice = response.data;
            if (this.deviceId) {
              this.mobileDevice.forEach((element) => {
                if (this.deviceId == element.id) {
                  this.deviceName = element.name;
                  this.restorePublishForm.controls['mobileDeviceName'].setValue(
                    this.deviceId
                  );
                }
              });
            } else {
              let deviceId = response.data[0].id;
              this.restorePublishForm.controls['mobileDeviceName'].setValue(
                deviceId
              );
            }
          } else {
            this.isLoading = false;
          }
        });
    } catch (error) {
      this.isLoading = false;
    }
    // Send Command
    this.isLoading = true;
    if (type == 'UNLOCK') {
      this.Locked = false;
    } else {
      this.Locked = true;
    }

    try {
      this.sendCommanddto.deviceId = id;
      this.sendCommanddto.requestType = type;
      this._Service
        .postService(this._Service.API_URL.sendCommand, this.sendCommanddto)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this._toastr.success('', response.status.message);
            this.isLoading = true;
            this._Service
              .getService(this._Service.API_URL.getLock + id)
              .subscribe((response) => {
                if (response && response.status.code === 200) {
                  this.isLoading = false;
                  this.lockData = response.data;
                } else {
                  this.isLoading = false;
                }
              });
            this.isLock = true;
          } else {
            this.isLoading = false;
            this._toastr.error('', response.status.message);
          }
        });
    } catch (error) {
      this.isLoading = false;
    }
  }

  //Updated send command for Anti-theft

  sendCommand6() {
    $('#AntiTheftPopup').modal('show');
  }
  closeModal3() {
    $('#AntiTheftPopup').modal('hide');
    this.autodial = false;
  }

  closeModal4() {
    $('#deviceCommandPopup').modal('hide');
  }

  closeModal5() {
    $('#actNowPopup').modal('hide');
  }
  // Send Command
  sendCommand7(id: any, type: any) {
    this.isLoading = true;
    try {
      if (this.getRequestType === 'CALL') {
        this.sendCommanddto.mobileNo =
          this.autoDialForm.controls['mobileNo'].value.number;
      }
      this.sendCommanddto.deviceId = id;
      this.sendCommanddto.requestType = this.getRequestType;
      this._Service
        .postService(this._Service.API_URL.sendCommand, this.sendCommanddto)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this.autodial = false;
            if (this.getRequestType === 'PHOTO') {
              this._toastr.success(
                this._translate.instant("TOSTRMSGS.QH_TOSTR_ANTI_THEFT_PHOTO")
              );
            } else if (this.getRequestType === 'VIDEO') {
              this._toastr.success(
                this._translate.instant("TOSTRMSGS.QH_TOSTR_ANTI_THEFT_VIDEO")
              );
            } else if (this.getRequestType === 'AUDIO') {
              this._toastr.success(
                this._translate.instant("TOSTRMSGS.QH_TOSTR_ANTI_THEFT_AUDIO")
              );
            } else {
              this._toastr.success('', response.status.message);
            }

            this.autoDialForm.reset();
            this.sendCommanddto.mobileNo = '';
          } else {
            this._toastr.error('', response.status.message);
            this.isLoading = false;
          }
          this.isLoading = false;
        });
    } catch (error) {
      this.isLoading = false;
    }

    // Fethcing the Device Details here
    this.isLoading = true;
    try {
      this._Service
        .getService(this._Service.API_URL.getPremiumDeviceInUser)
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this.mobileDevice = response.data;
            if (id) {
              this.mobileDevice.forEach((element: any) => {
                if (id) {
                  this.isPremium = element.isPremium;
                  let isAutoDialAllowed = element.isAutoDialAllowed;

                  if (isAutoDialAllowed) {
                    this.tabsData.forEach((ele: any) => {
                      if (ele.requestType === 'CALL') {
                        ele.isAutoDialAllowed = false;
                      }
                    });
                  }

                  this.restorePublishForm.controls['mobileDeviceName'].setValue(
                    element.id
                  );
                }
              });
            } else {
              this.isPremium = response.data[0].isPremium;
              let deviceId = response.data[0].id;
              let isAutoDialAllowed = response.data[0].isAutoDialAllowed;

              if (isAutoDialAllowed) {
                this.tabsData.forEach((ele: any) => {
                  if (ele.requestType === 'CALL') {
                    ele.isAutoDialAllowed = false;
                  }
                });
              }
              this.restorePublishForm.controls['mobileDeviceName'].setValue(
                deviceId
              );
            }
          } else {
            this.isLoading = false;
          }
        });
    } catch (error) {
      this.isLoading = false;
    }
  }

  selectedIndex1(i: any, data: any) {
    this.getRequestType = data;
    this.autodial = true;
    this.errorMessage = '';
    if (data !== 'CALL') {
      this.autodial = false;
    }
    this.getAntitheftCommandData(this.getRequestType, i);
  }

  // Fetching the data for the antitheft
  getAntitheftCommandData(requestType: any, id: any) {
    this.isLoading = true;
    this._Service
      .getService(
        this._Service.API_URL.getAntitheftCommandData +
        id +
        '?requestType=' +
        requestType
      )
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.antitheftData = response.data;
        }
        this.isLoading = false;
      });
  }

  onMobileDeviceSelect(event: any) {
    this.deviceId = event.target.value;
    let isAutoDialAllowed: boolean = false;
    this.mobileDevice.forEach((element: any) => {
      if (element.id === this.deviceId) {
        isAutoDialAllowed = element.isAutoDialAllowed;
      }
    });

    this.tabsData.forEach((element: any) => {
      if (element.requestType === 'CALL') {
        if (isAutoDialAllowed) {
          element.isAutoDialAllowed = false;
        } else {
          element.isAutoDialAllowed = true;
          this.selectedI = 0;
        }
      }
    });
  }

  removeSpace1(event: any) {
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }

  onSubmit(id: any, type: any) {
    this.sendCommand7(id, type);
  }

  // Fetching the Lock date data here
  getLock(id: any) {
    this.isLoading = true;
    this._Service
      .getService(this._Service.API_URL.getLock + id)
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.lockData = response.data;
        } else {
          this.isLoading = false;
        }
      });
  }

  openLockModal() {
    $('#LockPopup').modal('show');
    this.isLock = true;
  }

  closeModal1() {
    $('#LockPopup1').modal('hide');
  }
  syncScoreArr: any = [];
  productVersion: any;
  openSyncScoreModal(id: any, type: any) {
    $('#actNowPopup').modal('hide');
    this.syncScoreArr = [];
    this.syncScoreArr.push(id, type);
    if (this.openMyDeviceContent) {
      this.buildVersion = this.getMyDeviceData
        .filter((device: { id: any }) => device.id == id)
        .map((i: { buildVersion: any }) => i.buildVersion);
    } else {
      this.buildVersion = this.getUserIndexData?.buildVersion;
    }

    if (this.buildVersion >= '4.00.02') {
      this.sendCommand8(id, 'UPDATE_ALL_DETAILS');
    } else {
      this.sendCommand8(id, 'UPDATE_ALL_DETAILS');
      this.sendCommand8(id, 'SCORE');
    }
  }

  openSyncScoreModalnew(
    id: any,
    type: any,
    deviceType: any,
    isMyDevice: boolean
  ) {
    deviceType = 'SYSTEM';
    this.syncScoreArr = [];
    this.syncScoreArr.push(id, type, deviceType);
    if (isMyDevice) {
      this.productKeyType = this.getMyDeviceData
        .filter((device: { id: any }) => device.id == id)
        .map((i: { productKeyType: any }) => i.productKeyType);
    } else {
      this.productKeyType = this.allOtherDevices
        .filter((device: { id: any }) => device.id == id)
        .map((i: { productKeyType: any }) => i.productKeyType);
    }
    if (
      this.productKeyType == 'SYSTEM' ||
      this.productKeyType == 'FAMILY_PACK'
    ) {
      this.sendDesktopCommand(id, deviceType, type);
    }
  }

  //send command
  sendCommand8(id: any, type: any) {
    this.isLoading = true;
    try {
      this.sendCommanddto.deviceId = id;
      this.sendCommanddto.requestType = type;

      this._Service
        .postService(this._Service.API_URL.sendCommand, this.sendCommanddto)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            $('#LockPopup').modal('show');
            this.isLock = false;
            setTimeout("$('#LockPopup').modal('hide');", 1500);
            this._toastr.success('', response.status.message);
          } else {
            this._toastr.error('', response.status.message);
          }
          this.isLoading = false;
        });
    } catch (error) {
      this.isLoading = false;
    }

    //  Get All Device
    // Fetching all mobile device added from Manage Device
    this.isLoading = true;
    try {
      this._Service
        .getService(this._Service.API_URL.getDevicesInUser)
        .subscribe((response: any) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this.mobileDevice = response.data;
            if (this.deviceId) {
              this.mobileDevice.forEach((element: any) => {
                if (this.deviceId == element.id) {
                  this.deviceName = element.deviceName;
                  this.restorePublishForm.controls['mobileDeviceName'].setValue(
                    element.id
                  );
                }
              });
            } else {
              let deviceId = response.data[0].id;
              this.restorePublishForm.controls['mobileDeviceName'].setValue(
                deviceId
              );
            }
          } else {
            this.isLoading = false;
          }
        });
    } catch (error) {
      this.isLoading = false;
    }
  }

  gotoCommands(id: any, type: any) {
    $('#LockPopup1').modal('hide');
    sessionStorage.setItem('Deviceid', JSON.stringify(id));
    if (type === 'TRACE') {
      this._router.navigateByUrl(`/home/locate-device/${id}`);
    } else if (type === 'SCAN_FROM_CLOUD') {
      this._router.navigateByUrl(`/home/scan-device/${id}`);
    } else if (type === 'ANTITHEFT_SETTINGS') {
      this._router.navigateByUrl(`/home/anti-theft-device/${id}`);
    } else if (type === 'WIPE') {
      this._router.navigateByUrl(`/home/wipe-device/${id}`);
    } else if (type === 'BLOCK') {
      this._router.navigateByUrl(`/home/lock-device/${id}`);
    } else if (type === 'UPDATE_VIRUS_DB') {
      this._router.navigateByUrl(`/home/update-virus-device/${id}`);
    } else if (type === 'SYNC_DEVICE') {
      this._router.navigateByUrl(`/home/sync-device/${id}`);
    } else if (type === 'RING_DEVICE') {
      this._router.navigateByUrl(`/home/ring-device/${id}`);
    } else if (type == 'SCORE') {
      this._router.navigateByUrl(`/home/sync-score/${id}`);
    }
  }

  // Openign the Add User Modal Here
  openAddUser() {
    $('#transferOwnershipPopup').modal('hide');
    this._router.navigate(['home/add-user']);
  }

  dashboardMarkup: any[] = [];
  dashboardOptions: OwlOptions = {
    loop: true,
    dots: true,
    nav: false,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    autoplaySpeed: 1200,
    mouseDrag: true,
    autoWidth: true,
    touchDrag: false,
    pullDrag: false,
    margin: 10,
    stagePadding: 0,
    responsive: {
      0: {
        dotsEach: 5,
        items: 1,
      },
      300: {
        items: 1,
      },
    },
  };

  getAllUserLicense() {
    try {
      this.isLoading = true;
      this._Service
        .getService(this._Service.API_URL.getAllMyLicense)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this.dashboardMarkup = response?.data?.myLicenseList;

            this.dashboardMarkup.forEach((resp: any) => {
              if (resp.licenseValidityDate != 'Free version') {
                let a = resp.licenseValidityDate.split('(');
                const date1: any = new Date(a[0]);
                const date2: any = new Date();
                const diffTime: any = Math.abs(date2 - date1);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                if (date2 < date1) {
                  resp['aboutToExpire'] = Number(diffDays) <= 15;
                } else {
                  resp['aboutToExpire'] = true;
                }
              }
            });
            let shownTabs: any[] = this.dashboardMarkup.filter(
              (slide: any) =>
                slide.licenseValidityDate == 'Free version' ||
                (slide.licenseValidityDate.includes('Premium Validity') &&
                  slide.aboutToExpire)
            );
            this.dashboardOptions.loop = shownTabs?.length > 1;
          } else {
            this.isLoading = false;
          }
        });
    } catch (error) {
      this.isLoading = false;
    }
  }

  // Opening The Input for device name change
  previousName: string = '';
  currentUserName: string = '';
  openDeviceInput(id: any, type: any, deviceName?: any) {
    this.previousName = this.deviceUpdatedName;
    this.currentUserName = this.updateName;
    if (type == 'MYDEVICEUSERNAME') {
      this.enableMyDeviceNameInput = true;
    } else {
      this.enableMyUserDeviceNameInput = true;
    }

    if (type == 'MYUSERNAME') {
      this.enableMyCurrentUserNameInput = true;
    } else {
      this.enableMyUserNameInput = true;
    }
  }

  //  Updateing Device Name
  updateDevice(deviceType: any, deviceId: any) {
    if (this.previousName != this.deviceUpdatedName) {
      let formData = {
        productKeyType: deviceType,
        productKeyOrDeviceId: deviceId,
        deviceName: this.deviceUpdatedName,
      };
      this._service
        .postService(this._service.API_URL.updateDevice, formData)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this._toastr.success('', response.status.message);
            setTimeout(() => {
              this.getAllDevice();
            }, 100);
            this.enableMyDeviceNameInput = false;
            this.enableMyUserDeviceNameInput = false;
          } else {
            this._toastr.error('', response.status.message);
          }
        });
    } else {
      this._toastr.error('', this._translate.instant('MANAGEDEVICE.ERRORSAMEDEVICENAME'));
    }
  }

  updateUserName(deviceType: any, deviceId: any) {
    if (this.currentUserName != this.updateName) {
      let formData = {
        productKeyType: deviceType,
        productKeyOrDeviceId: deviceId,
        currentUserName: this.updateName,
      };
      this._service
        .postService(this._service.API_URL.updateUsername, formData)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this._toastr.success('', response.status.message);
            setTimeout(() => {
              this.getAllDevice();
            }, 100);
            this.enableMyUserNameInput = false;
            this.enableMyCurrentUserNameInput = false;
          } else {
            this._toastr.error('', response.status.message);
          }
        });
    } else {
      this._toastr.error('', this._translate.instant('MANAGEDEVICE.ERRORSAMEUSERNAME'));
    }
  }

  //  Sending Command Score
  sendDesktopCommand(id: any, deviceType: any, type: any) {
    this.isLoading = true;
    try {
      this.sendCommanddto.deviceId = id;
      this.sendCommanddto.productKeyType = deviceType;
      this.sendCommanddto.systemRequestType = type;
      this.deviceId = id;
      this._service
        .postService(this._service.API_URL.sendCommand, this.sendCommanddto)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this._toastr.success('', response.status.message);
          } else {
            this.isLoading = false;
            if (type === 'SCAN_FROM_CLOUD') {
              $("#scanPopup").modal('show');
            } else {
              this._toastr.error('', response.status.message);
            }
          }
          if (type === 'SCAN_FROM_CLOUD') {
            this.disableScanButton();
          }
        });
    } catch (error) { }
  }
  disableScanButton() {
    this.isScanButtonDisabled = true;
    const reenableTime = Date.now() + 15 * 60 * 1000;
    localStorage.setItem('scanBtnDisabledUntil_' + this.deviceId, reenableTime.toString());

    setTimeout(() => {
      this.isScanButtonDisabled = false;
      localStorage.removeItem('scanBtnDisabledUntil_' + this.deviceId);
    }, 15 * 60 * 1000);
  }
  closeVerifyDetails() {
    this.isMobile = false;
    this.isOTP = false;
    this.isDone = false;
    this.deviceDetailForm.reset();
    $('#verifyDetailsPopup').modal('hide');
    this._router.navigateByUrl('/home/add-device');
  }

  managedDeviceControlBtnClick($event: any, id: any) {
    this._router.navigateByUrl(
      `/home/manage-device-control/${id}` + '?userId=' + this.selectedUserId
    );
  }
  fetchSettingStatus(id: any, productKeyType: any) {
    this.isLoading = true;
    try {
      this._service
        .getService(this._service.API_URL.getSettingStatus + id + '/' + productKeyType)
        .subscribe((response) => {
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this.getMyIndexData = {
              ...this.getMyIndexData,
              ...response.data
            };
            this._toastr.success('', response.status.message);
          } else {
            this.isLoading = false;
            this._toastr.error('', response.status.message);
          }
        });
    } catch (error) { }
  }
  managedSystemControlBtnClick(userId: any, systemId: any) {
    this._router.navigateByUrl(
      `/home/desktop-settings/${this.selectedUserId}` + '?systemId=' + systemId
    );
  }

  showSendControlPopup() {
    //   $("#controlRequestPopup").modal("show");
  }

  hideSendControlPopup() {
    $("#controlRequestPopup").modal("hide");
    $("#multiControlRequestPopup").modal("hide");
  }

  sendCommands() {
    try {
      this._service.postService(this._service.API_URL.resendFailedCommand, this.sendCommanddto).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this._toastr.success('', response.status.message);
          this.hideSendControlPopup();
        } else {
          this.isLoading = false;
          this._toastr.error('', response.status.message);
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  typeToDisplayNameMap: { [key: string]: string } = {

    SYSTEM_PARENTAL_SETTINGS: this._translate.instant('SETTINGS.PARENTALCONTROL'),
    SMART_PARENTING_SETTING: this._translate.instant('SETTINGS.PARENTALCONTROL'),
    SCREEN_TIME_SETTING: this._translate.instant('SETTINGS.SCREENTIME'),
    YOUTUBE_SUPERVISION_SETTING: this._translate.instant('SETTINGS.YOUTUBESUPERVISION'),
    ANTITHEFT_SETTING: this._translate.instant('SETTINGS.ANTITHEFT'),
    PIN_SETTING: this._translate.instant('SETTINGS.PIN_SETTING'),
    VIRUS: this._translate.instant('SETTINGS.VIRUS_PROTECTION'),
    FIREWALL: this._translate.instant('SETTINGS.FIREWALLIDSIPSP'),
    RANSOMEWARE: this._translate.instant('SETTINGS.RANSOMWARE_PROTECTION'),
  };
  requestTypeDisplayNames: string[] = []

  openSendControlPopup(id: any, type: any, productType: any, deviceName: any) {
    this.sendCommanddto.deviceId = id;
    this.sendCommanddto.productKeyType = productType;
    this.cmdfailedDeviceName = deviceName;
    const items = type
      .split(',')
      .map((item: any) => item.trim())
      .filter((item: any) => item !== '');
    const uniqueItems = Array.from(new Set(items)) as string[];
    this.requestTypes = uniqueItems.join(', ');
    if (type == 'FIREWALL' || type == 'VIRUS' || type == 'RANSOMEWARE') {
      type = 'PROTECTION_SETTINGS';
      this.sendCommanddto.settingFailureTypes = type;
    } else {
      this.sendCommanddto.settingFailureTypes = uniqueItems.join(', ');
    }

    let typeArray: string[] = Array.isArray(type)
      ? type
      : type.split(',').map((item: string) => item.trim());

    if (productType == 'MOBILE') {
      const transformedTypes = typeArray.map((types: string) => {
        if (types === 'Smart Parenting') return 'SMART_PARENTING_SETTING';
        if (types === 'YouTube Supervision') return 'YOUTUBE_SUPERVISION_SETTING';
        if (types === 'Anti Theft') return 'ANTITHEFT_SETTING';
        if (types === 'ScreenTime') return 'SCREEN_TIME_SETTING';
        if (types === 'Device Pin') return 'PIN_SETTING';
        if (types === 'SMART_PARENTING_SETTING') return 'SMART_PARENTING_SETTING';
        if (types === 'YOUTUBE_SUPERVISION_SETTING') return 'YOUTUBE_SUPERVISION_SETTING';
        if (types === 'ANTITHEFT_SETTING') return 'ANTITHEFT_SETTING';
        if (types === 'SCREEN_TIME_SETTING') return 'SCREEN_TIME_SETTING';
        if (types === 'PIN_SETTING') return 'PIN_SETTING';
        return types;
      });
      const uniqueTypes = Array.from(new Set(transformedTypes));
      this.sendCommanddto.settingFailureTypes = uniqueTypes.join(', ').trim();;

    }


    if (productType == 'SYSTEM') {
      const transformedTypes = typeArray.map((types: string) => {
        if (types === 'SYSTEM_PARENTAL_SETTINGS') return 'SYSTEM_PARENTAL_SETTINGS';
        if (types === 'RAMSOMEWARE') return 'PROTECTION_SETTINGS';
        if (types === 'FIREWALL') return 'PROTECTION_SETTINGS';
        if (types === 'VIRUS') return 'PROTECTION_SETTINGS';
        if (types === 'Smart Parenting') return 'SYSTEM_PARENTAL_SETTINGS';
        if (types === 'Virus') return 'PROTECTION_SETTINGS';
        if (types === 'Firewall') return 'PROTECTION_SETTINGS';
        if (types === 'Ransomeware') return 'PROTECTION_SETTINGS';
        if (types === 'IDS/IPS') return null;
        return types;
      });
      const uniqueTypes = Array.from(new Set(transformedTypes));
      this.sendCommanddto.settingFailureTypes = uniqueTypes.join(', ').trim();;
    }

    this.requestTypeDisplayNames = uniqueItems.map(
      (item: string) => this.typeToDisplayNameMap[item] || item
    );
    $("#controlRequestPopup").modal("show");
  }


  openSendMultiControlPopup(id: any, type: any, productType: any, deviceName: any) {
    this.sendCommanddto.deviceId = id;
    this.sendCommanddto.productKeyType = productType;
    this.cmdfailedDeviceName = deviceName;
    let typeArray: string[] = Array.isArray(type)
      ? type
      : type.split(',').map((item: string) => item.trim());

    if (productType == 'MOBILE') {
      const transformedTypes = typeArray.map((types: string) => {
        if (types === 'Smart Parenting') return 'SMART_PARENTING_SETTING';
        if (types === 'YouTube Supervision') return 'YOUTUBE_SUPERVISION_SETTING';
        if (types === 'Anti Theft') return 'ANTITHEFT_SETTING';
        if (types === 'ScreenTime') return 'SCREEN_TIME_SETTING';
        if (types === 'Device Pin') return 'PIN_SETTING';
        if (types === 'SMART_PARENTING_SETTING') return 'SMART_PARENTING_SETTING';
        if (types === 'YOUTUBE_SUPERVISION_SETTING') return 'YOUTUBE_SUPERVISION_SETTING';
        if (types === 'ANTITHEFT_SETTING') return 'ANTITHEFT_SETTING';
        if (types === 'SCREEN_TIME_SETTING') return 'SCREEN_TIME_SETTING';
        if (types === 'PIN_SETTING') return 'PIN_SETTING';
        return types;
      });
      const uniqueTypes = Array.from(new Set(transformedTypes));
      this.sendCommanddto.settingFailureTypes = uniqueTypes.join(', ').trim();;

    }


    if (productType == 'SYSTEM') {
      const transformedTypes = typeArray.map((types: string) => {
        if (types === 'SYSTEM_PARENTAL_SETTINGS') return 'SYSTEM_PARENTAL_SETTINGS';
        if (types === 'RAMSOMEWARE') return 'PROTECTION_SETTINGS';
        if (types === 'FIREWALL') return 'PROTECTION_SETTINGS';
        if (types === 'VIRUS') return 'PROTECTION_SETTINGS';
        if (types === 'Smart Parenting') return 'SYSTEM_PARENTAL_SETTINGS';
        if (types === 'Virus protection') return 'PROTECTION_SETTINGS';
        if (types === 'Firewall') return 'PROTECTION_SETTINGS';
        if (types === 'Ransomeware protection') return 'PROTECTION_SETTINGS';
        if (types === 'IDS/IPS protection') return null;
        return types;
      });
      const uniqueTypes = Array.from(new Set(transformedTypes));
      this.sendCommanddto.settingFailureTypes = uniqueTypes.join(', ').trim();;
    }

    const items = type
      .split(',')
      .map((item: any) => item.trim())
      .filter((item: any) => item !== '');
    const uniqueItems = Array.from(new Set(items)) as string[];
    this.requestTypes = uniqueItems.join(', ');

    this.requestTypeDisplayNames = uniqueItems.map(
      (item: string) => this.typeToDisplayNameMap[item] || item
    );
    this.requestTypeDisplayNames = this.requestTypeDisplayNames
    $("#multiControlRequestPopup").modal("show");
  }

  failedSettings: string[] = [];
  selectedIndexfailure(data: any) {
    this.failedSettings = [];

    if (data.spStatus === 'FAILED' && data.deviceType == 'MOBILE') {
      this.failedSettings.push(this._translate.instant('SETTINGS.SP'));
    }

    if (data.dpStatus === 'FAILED') {
      this.failedSettings.push(this._translate.instant('DASHBOARD.PIN_SETTING'));
    }

    if (data.youtubeStatus === 'FAILED') {
      this.failedSettings.push(this._translate.instant('SETTINGS.YOUTUBESUPERVISION'));
    }

    if (data.atStatus === 'FAILED') {
      this.failedSettings.push(this._translate.instant('SETTINGS.ANTITHEFT'));
    }
    if (data.stStatus === 'FAILED') {
      this.failedSettings.push(this._translate.instant('SETTINGS.SCREENTIMES'));
    }

    if (data.spStatus === 'FAILED' && data.deviceType == 'SYSTEM') {
      this.failedSettings.push(this._translate.instant('SETTINGS.SP'));
    }
    if (data.vpStatus === 'FAILED') {
      this.failedSettings.push(this._translate.instant('SETTINGS.VP'));
    }

    if (data.rpStatus === 'FAILED') {
      this.failedSettings.push(this._translate.instant('SETTINGS.RP'));

    }

    if (data.fpStatus === 'FAILED') {
      this.failedSettings.push(this._translate.instant('SETTINGS.FIREWALL_IDS'));
    }
  }

  getFailedCount(): number {
    return this.failedSettings.length;
  }

  getFirstSetting(): string {
    return this.failedSettings[0];
  }


  hasControlFailure(device: any): boolean {
    if (!device) return false;

    const statuses = Object.keys(device)
      .filter(key => key.toLowerCase().endsWith('status'))
      .map(key => (device as any)[key]);

    return statuses.some(status => (status || '').trim().toLowerCase() === 'failed');
  }

  hasAnyTag(item: any): boolean {
    return (
      (item?.securityStatus === 'secure' && item?.expiringStatus === 'LICENSE_EXPIRING_SOON') ||
      (item?.detected === true && item?.expiringStatus === 'LICENSE_EXPIRING_SOON') ||
      (item?.securityStatus === 'secure' && item?.licenseValidityDate === 'Free version') ||
      (item?.detected === true && item?.licenseValidityDate === 'Free version') ||
      (item?.deviceType === 'MOBILE' && (item?.spStatus === 'FAILED' || item?.atStatus === 'FAILED' || item?.youtubeStatus === 'FAILED' || item?.stStatus === 'FAILED' || item?.dpStatus === 'FAILED')) ||
      (item?.deviceType === 'SYSTEM' && (item?.spStatus === 'FAILED' || item?.vpStatus === 'FAILED')) ||
      (item?.deviceType === 'SYSTEM' && parseFloat(item?.buildVersion) < parseFloat(this.DeskCompatibleVer)) ||
      (item?.deviceType === 'MOBILE' && !this.isCompatible(item?.buildVersion))
    );
  }

  roleMap: { [key: string]: string } = {
    'Super Admin': 'MANAGEUSER.SUPERADMIN',
    'Admin': 'MANAGEUSER.ADMIN',
    'Member': 'MANAGEUSER.MEMBER',
    'Child': 'MANAGEUSER.CHILD'
  };

  getRoleLabel(roleStr: string): string {
    const key = this.roleMap[roleStr];
    return key ? this._translate.instant(key) : roleStr;
  }

}
